/* unplugin-vue-components disabled */import script from "./login-register.vue?vue&type=script&setup=true&lang=js"
export * from "./login-register.vue?vue&type=script&setup=true&lang=js"

import "./login-register.vue?vue&type=style&index=0&id=413db8d3&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-413db8d3"]])

export default __exports__